module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxlist/inboxlist_img01-f6045936b9b8c671ac0bcc4191276788.jpg";